import { createBrowserOnlyLazyComponent } from '@dbh/react-lazy';
import _isEmpty from 'lodash/isEmpty';
import 'prop-types';
import { isImmutable } from 'immutable';
import { useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getFormSyncErrors } from 'redux-form/immutable';
import { scrollFocusToFirstFormError } from '@dbh/redux-form';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';

const useHandleBraintreeEntryContentVisibility=withConformsTo("useHandleBraintreeEntryContentVisibility",[],a=>{let{form:b,fieldsToBlur:c,blur:d,valid:e}=a;const[f,g]=useState(!1),h=useSelector(useMemo(()=>getFormSyncErrors(b),[b])),i=useCallback(()=>{c.forEach(a=>{d(a);});const a=isImmutable(h)?h.toObject():h;return e||_isEmpty(a)?void g(!0):void scrollFocusToFirstFormError(h)},[c,h,e,d]),j=useCallback(()=>{g(!1);},[g]);return {isPaymentMethodEntryContentVisible:f,handleButtonClick:i,onCloseEntryContent:j}});var useHandleBraintreeEntryContentVisibility$1 = useHandleBraintreeEntryContentVisibility;

var index = createBrowserOnlyLazyComponent(()=>import('./component-2003e6b4.js'/* webpackChunkName: "dbh.payment-methods" */));

export { index as default, useHandleBraintreeEntryContentVisibility$1 as useHandleBraintreeEntryContentVisibility };
